module.exports = __webpack_public_path__ + "static/media/languages.8030c988.jpg";